import React, { useEffect, useState } from 'react'
import store from '../../../store';
import { connect } from "react-redux";
import Button from './input/Button'
import Input from './input/Input'
import { apiUrl } from './constants';
import { GetRequest, PostRequest, stopTimer, countdown } from './helper';
import { ExIcon } from './svg';
import AccountLoader from '../../manageAccount/accountLoader';
import { updatePnrEnqiryData, updatePnrEnqiryTripData } from '../../../actions/search-actions';
import Card from './card';
import Alert from './Alert';
import Bookingcard from './bookingcard';
import OtpForm from '../../common/cancelRequestForm';
import GInput from '../../common/input/ginput';
import { renderImg } from '../../common/icons/img';
import { getparamsString } from '../../common/helper';
import { MOB_NUM, MOB_NUM_ERR, PNR_NUM, ENTER_OTP, VERIFY, RESEND_OTP_IN, RESEND_OTP_NOW, ENTER_VALID_OTP, t } from '../../../translations/pnrEnquiry/BusPnr';
import { tCommon, SEARCH,LOCKOTP_MSG } from '../../../translations/Common';
import { RECAPTCHA_FAIL, RECAPTCHA_LOADING, t as tLogin } from '../../../translations/Login';

const PnrTicket = (props) => {
    const { setCardData, captchaToken, refreshCaptchaToken } = props
    const propdata = store.getState();
    const pnrEnquiryData = propdata.search.pnrEnquiryData;
    const [user, setUser] = useState({ pnr: '', mobile: '', otp: '' });
    const [loader, setLoader] = useState(false);
    const [alert, setAlert] = useState({ show: false, msg: '' });
    const [password, setPassword] = useState("");
    const [otpSent, setOtpSent] = useState(false);
    const [resend, setResend] = useState("");
    const [togglePassword, setTogglePassword] = useState(false);
    const [otpRequest, setOtpRequest] = useState(false);
    const [invalidOTP, setInvalidOTP] = useState(false);
    const [isLockedOTP, setIsLockedOTP] = useState(false);

    const handleChange = (val, param) => {
        user[param] = val;//val.replace(/[^\w\s]/gi, '');
        setUser({ ...user });
    }

    useEffect(() => {
        stopTimer();
    }, [])

    const handleAlert = (msg = false) => {
        if (msg) {
            setAlert({ show: true, msg });
        } else {
            setAlert({ show: false, msg: '' })
        }
    }

    const verifyRecaptcha = async () => {
        if (!captchaToken) {
            return { Success: false, ErrorMessage: tLogin(RECAPTCHA_LOADING) };
        }
        setLoader(true);
        try {
            const res = await PostRequest(apiUrl.validateCaptcha, { response: captchaToken });
            setLoader(false);
            return res || { Success: false, ErrorMessage: tLogin(RECAPTCHA_FAIL) };
        } catch (err) {
            setLoader(false);
            return { Success: false, ErrorMessage: tLogin(RECAPTCHA_FAIL) };
        }
    };

    const getParseData = (data) => {
        let resp = {};
        let rs = [];
        if (data.pnrNo || data.OldFormatPNR) {
            resp.JourneyDate = data.JourneyDate;
            resp.TripCode = data.TripCode;
            resp.BusType = data.BusDetails[0].BusType;
            resp.ArrivalTime = data.BusDetails[0].DropoffTime;
            resp.BookingDateTime = data.BookingTime;
            resp.BookingRefNo = data.pnrNo;
            resp.DepartureTime = data.BusDetails[0].PickupTime;
            resp.DropoffID = data.BusDetails[0].DropoffID;
            resp.DroppoffName = data.BusDetails[0].DropOffName;
            resp.FromCityName = data.BusDetails[0].FromCity;
            resp.ToCityName = data.BusDetails[0].ToCity;
            resp.FromCityID = data.BusDetails[0].FromCityID;
            resp.ToCityID = data.BusDetails[0].ToCityID;
            resp.PickupID = data.BusDetails[0].PickupID;
            resp.PickupName = data.BusDetails[0].PickupName;
            resp.RouteCode = data.RouteCode;
            resp.PNR = data.OldFormatPNR;
            resp.mobile = data.MobileNo;
            resp.BookingStatus = data.BookingStatus === 'Booking' ? "B" : "C";
            resp.IsLinkBooking = data.IsLinkBooking;
            resp.showCancel = false;
            resp.showEdit = false;
            resp.viewBokking = false;
            rs.push(resp);
        }
        return rs;
    }

    const verify = async () => {
        const captchaRes = await verifyRecaptcha();
        if (typeof refreshCaptchaToken === 'function') {
            refreshCaptchaToken();
        }
        if (!captchaRes?.Success) {
            setAlert({ show: true, msg: captchaRes?.ErrorMessage || tLogin(RECAPTCHA_FAIL) });
            return;
        }

        const mobile = user.mobile;
        const pnr = `${user.pnr}`;

        setInvalidOTP(false);
        setIsLockedOTP(false);
        setLoader(true);

        const url = `${apiUrl.validateOTPV2}?OTP=${password}&mobileNo=${mobile}`;
        GetRequest(url).then(result => {
            setLoader(false);
            if (result.Success) {
                stopTimer();
                // getStatusDetails(pnr);
                getPnrDetail(pnr);
            } else {
                result?.IsLocked ? setIsLockedOTP(true) : setInvalidOTP(true);
            }
        }).catch((err) => {
            console.log("err", err);
            setLoader(false);
        });
    }

    const getStatusDetails = (pnr) => {
        if (pnr) {
            // setLoader(true);
            const mobile = user.mobile;
            const url = `${apiUrl.statusDetails}?searchVal=${pnr}&mode=P`;
            GetRequest(url).then(res => {
                //stopTimer();
                setLoader(false);
                setOtpRequest(false);
                if (res.IsSuccess && res.Data && res.Data.length > 0) {
                    store.dispatch(updatePnrEnqiryData(res.Data));
                    store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
                } else {
                    store.dispatch(updatePnrEnqiryData(false));
                    store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
                    setAlert({ show: true, msg: 'PNR not found' })
                }
            })
        } else {
            setAlert({ show: true, msg: 'Please enter valid PNR Ticket' })
        }
    }

    const generateOtp = () => {

        const mobile = user.mobile;
        const pnrNo = user.pnr;

        if (mobile && String(mobile).length === 10 && mobile > 6000000000) {

            setLoader(true);

            const verifyUrl = `${apiUrl.verifyMobileByPnr}?MobileNo=${mobile}&PNRNo=${pnrNo}`;

            GetRequest(verifyUrl).then(verifyRes => {
                if (verifyRes.Success === true) {

                    const url = `${apiUrl.generateOTPV2}?mobileNo=${mobile}&type=pnrEnquiry`;
                    GetRequest(url).then(res => {
                        if (res.Success === true) {
                            countdown('mobileClock', 3, 0, setResend);
                            setOtpRequest(true);
                            setOtpSent(true);
                            setResend("disable");
                        }else{
                            setAlert({ show: true, msg: res.ErrorMessage})         
                        }
                        setLoader(false);
                    })

                }else{
                    // Mobile + PNR verification failed
                    setAlert({
                        show: true,
                        msg: verifyRes.ErrorMessage
                    });

                    setLoader(false);
                }
            })

        } else {
            setAlert({ show: true, msg: 'Please enter valid Mobile no' })
        }
        user.otp = '';
        setPassword("");
        setUser({ ...user });
    }

    const getPnrDetail = (pnr) => {
        const mobile = user.mobile;
        // setLoader(true);
        if (pnr) {
            setLoader(true);
            const data = {
                PNR: pnr,
                mobile: mobile
            };
            const url = `${apiUrl.bookingInfo}` + "?" + getparamsString(data);
            GetRequest(url)
                .then((res) => {
                    setLoader(false);
                    if (res.Status && !res.Error) {
                        let bookingInfo = res.BookingInfo.APIGetBookingDetailsResult[0];
                        if (bookingInfo.PassengerContactNo1 == mobile) {
                            getStatusDetails(pnr)
                        } else {
                            setOtpRequest(false);
                            store.dispatch(updatePnrEnqiryData([]));
                            store.dispatch(updatePnrEnqiryTripData({ topDtls: {}, pickdropDtls: {} }));
                            // /setAlert({ show: true, msg: 'Please enter valid Details' })
                        }
                    }
                })
                .catch((err) => {
                    setLoader(false);
                    console.log(err);
                });
        }
    }

    const handelCloseOtpForm = (val) => {
        stopTimer();
        setOtpRequest(val);
    }

    return (
        <>
            {loader && <AccountLoader />}
            {!pnrEnquiryData && <div className='bookingStatus-PNR'>
                <div className="pnr_container">
                    <div className='firstInput' style={{ width: '45%' }}>
                        <Input label={t(PNR_NUM)} type='tel' value={user.pnr} onChange={(e) => { handleChange(e, 'pnr') }} validation={'pnr'} errMsg='' autoFocus={true} />
                    </div>
                    <div className='secInput' style={{ width: '45%' }}>
                        <Input type='tel' label={t(MOB_NUM)} onChange={(val) => handleChange(val, 'mobile')} validation={'mobile'}
                            errMsg={t(MOB_NUM_ERR)} value={user.mobile} />
                    </div>
                    <div className="verify-button">
                        <Button text={tCommon(SEARCH)} className={`button ${(String(user.pnr).length >= 2 && String(user.mobile).length === 10) ? 'active' : 'disable'}`} extraStyle={{ "height": "48px" }} onClick={() => generateOtp()} />
                    </div>
                </div>
                <div className="bookingStatus-pnrMessage">
                    <div className="message" style={{ display: 'flex', marginTop: '6px' }}>
                        {/* <span style={{ marginRight: '8px', marginTop: '-2px' }}><ExIcon /></span><span>Enter the PNR No generated during booking</span> */}
                    </div>
                </div>
            </div>
            }
            {
                pnrEnquiryData && pnrEnquiryData.length > 0 &&
                <div className='booking-cards'>
                    <Bookingcard cardData={getParseData(pnrEnquiryData[0])} mobile={user.mobile} pnrTicket={true}/>
                </div>
            }
            {
                pnrEnquiryData && pnrEnquiryData.length === 0 &&
                <div className='booking-cards'>
                    <div style={{ fontSize: '16px', fontWeight: '500', textAlign: 'center' }}>You have no recent bookings.</div>
                </div>
            }
            {
                alert.show &&
                <Alert msg={alert.msg} error={true} close={() => handleAlert()} />
            }

            {
                otpRequest &&

                <OtpForm

                    msg={
                        < div
                            className="booking--inquiry"
                            style={{ justifyContent: "center" }}
                        >
                            <GInput
                                type={togglePassword ? "text" : "password"}
                                value={password}
                                onChange={(e) => setPassword(e)}
                                label={t(ENTER_OTP)}
                                key={"password"}
                                icon2={renderImg("view-icon")}
                                onIconClick={() =>
                                    setTogglePassword(!togglePassword)
                                }
                                autoFocus={true}
                                validation="password"
                                max={6}
                            />
                            <div className="cancel--request--btn" onClick={verify}>{t(VERIFY)}</div>
                            <div className="bookingStatus-message">
                                <div className="message" style={{ display: 'flex', paddingTop: '10px', justifyContent: 'center' }}>
                                    {
                                        resend === "" ? "" :
                                            resend === "Resend" ? <span style={{ color: 'var(--ksrtcThColor1)', cursor: 'pointer' }} onClick={generateOtp}>{t(RESEND_OTP_NOW)}</span> :
                                                <><span style={{ marginRight: '8px', marginTop: '-2px' }}><ExIcon /></span><span> {t(RESEND_OTP_IN)} </span> <span id="mobileClock" style={{ color: "red", marginLeft: '4px' }}></span></>
                                    }
                                </div>
                            </div>
                            {
                                invalidOTP && (
                                    <div className="bookingStatus-otp-message">
                                        <div className="otp-message">
                                            <span>{t(ENTER_VALID_OTP)}</span>
                                        </div>
                                    </div>
                                )
                            }

                            {
                                isLockedOTP && (
                                    <div className="bookingStatus-otp-message">
                                        <div className="otp-message">
                                            <span>{tCommon(LOCKOTP_MSG)}</span>
                                        </div>
                                    </div>
                                )
                            }

                        </div>
                    }

                    onClick={handelCloseOtpForm}    
                />

            }
        </>
    )
}

const mapStateToProps = function (store) {
    return store;
};
export default connect(mapStateToProps)(PnrTicket);